import * as yup from 'yup';

const dateRegex = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}$/;

export const schemaSchedule = yup.object().shape({
  title: yup.string().required('Título obrigatório'),
  start: yup
    .string()
    .required('Hora inicial obrigatória')
    .matches(dateRegex, 'Data obrigatória')
    .test('is-valid-date', 'Data inválida', (value) => {
      return !isNaN(Date.parse(value));
    }),

  end: yup
    .string()
    .required('Hora final obrigatória')
    .matches(dateRegex, 'Data obrigatória')
    .test(
      'is-greater',
      'A hora final deve ser maior que a inicial',
      function (value) {
        const { start } = this.parent;
        return value > start;
      },
    ),
  client_id: yup.string().required('Cliente obrigatório'),
  professional_id: yup.string().required('Profissional obrigatório'),
});
